import { useEffect, useRef } from "react"
import { useTouchInstance } from "resources/dashboard-instances"
import { useIsRealInstance } from "./use-is-real-instance"

export function useTouchInstanceOnOpen(dashboardId: string | null, canTouch: boolean): void {
  const isRealInstance = useIsRealInstance(dashboardId)
  const touchInstance = useTouchInstance()
  const touchedForRef = useRef<string | null>(null)

  useEffect(() => {
    if (!isRealInstance || !canTouch || dashboardId === null) return
    if (touchedForRef.current === dashboardId) return
    touchedForRef.current = dashboardId
    touchInstance(dashboardId).catch(() => undefined)
  }, [isRealInstance, canTouch, dashboardId, touchInstance])
}
